var parent = require('../../es/symbol');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/symbol/index.js
// module id = 4027
// module chunks = 25